module.exports = __webpack_public_path__ + "img/mutai_content_one.3f755f95.png";